import '.f9{max-width:360px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.a{padding:24px;}.ssr-plugin'
import '.fa{gap:0px;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.fb{top:116px;}.ssr-plugin'
import '.fc{z-index:1;}.ssr-plugin'
import '.fd{margin-bottom:6px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.ff{margin-top:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { useEffect, useRef } from 'react'
import { useLocation } from 'wouter'
import { colors } from '../utils/colors.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MENU_IN_FROM_TOP } from '../utils/animations.js'
import { Button } from './Button.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const Menu = ({
  setOpenMenu,
  totalVotes,
  hideCart,
  style,
  animation = MENU_IN_FROM_TOP,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const track = useTrack('menu')
  const [, setLocation] = useLocation()

  const {
    votingGroupTitle,
    start,
    cart,
    legalGroupTitle,
    votingIntegrity,
    termsOfService,
    privacyPolicy,
    imprint,
  } = useDictionary()

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        (e.target as HTMLElement).id ===
        'main-navbar-action-open-navigation-menu-button'
      ) {
        e.preventDefault()
      } else if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpenMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [setOpenMenu])

  return (
    <styled.div className="blur f9 m e f a fa cx a6 fb fc"
      ref={ref}
      id="main-navbar-navigation-menu"
      style={{
        border: `1px solid ${colors.border}`,
        backgroundColor: transparentColor(colors.secondary, 0.5),
        animation,
        ...style,
      }}
    >
      <p className="subtext fd bo"
      >
        {votingGroupTitle}
      </p>
      <Button
        id="main-navbar-navigation-menu-action-open-home"
        fullWidth
        variant="ghost"
        style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
        onClick={() => {
          setLocation('/')
          setOpenMenu(false)
        }}
      >
        {start}
      </Button>
      {!hideCart && (
        <Button
          id="main-navbar-navigation-menu-action-open-cart"
          fullWidth
          variant="ghost"
          style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
          onClick={() => {
            setLocation('/cart')
            setOpenMenu(false)
          }}
        >
          {cart} ({totalVotes})
        </Button>
      )}
      <p className="subtext ff fd bo"
      >
        {legalGroupTitle}
      </p>
      <Button
        fullWidth
        id="main-navbar-navigation-menu-action-open-voting-integrity"
        variant="ghost"
        style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
        onClick={() => {
          track(AnalyticsEvent.MENU_CLICK, '/voting-integrity')
          setLocation('/voting-integrity')
          setOpenMenu(false)
        }}
      >
        {votingIntegrity}
      </Button>
      <Button
        fullWidth
        id="main-navbar-navigation-menu-action-open-terms"
        variant="ghost"
        style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
        onClick={() => {
          track(AnalyticsEvent.MENU_CLICK, '/terms-of-service')
          setLocation('/terms-of-service')
          setOpenMenu(false)
        }}
      >
        {termsOfService}
      </Button>
      <Button
        fullWidth
        id="main-navbar-navigation-menu-action-open-privacy"
        variant="ghost"
        style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
        onClick={() => {
          track(AnalyticsEvent.MENU_CLICK, '/privacy-policy')
          setLocation('/privacy-policy')
          setOpenMenu(false)
        }}
      >
        {privacyPolicy}
      </Button>
      <Button
        fullWidth
        id="main-navbar-navigation-menu-action-open-imprint"
        variant="ghost"
        style={{
          marginLeft: '-16px',
          marginRight: '-16px',
          width: 'auto',
          marginBottom: '-12px',
        }}
        onClick={() => {
          track(AnalyticsEvent.MENU_CLICK, '/imprint')
          setLocation('/imprint')
          setOpenMenu(false)
        }}
      >
        {imprint}
      </Button>
    </styled.div>
  )
}
